import React from 'react'

import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'

import NavBar from '../../componentes/Navbar'

import AtendimentoService from '../../app/service/AtendimentoService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import ProcessoService from '../../app/service/ProcessoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './atendimento.css'

class HistoricoAtendimento extends React.Component {
  constructor(props) {
    super(props);

    this.atendimentoService = new AtendimentoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.processoService = new ProcessoService();

    this.template = this.template.bind(this);
    this.accept = this.accept.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this);

    this.state = {
      atendimento: null,
      historico: '',
      pessoa: '',
      assunto: '',
      grupos: [],
      grupo: '',
      selectProcesso: '',
      processoConsulta: '',
      processo: null,
      processos: [],
      selectGrupo: null,
      dtAtendimento: '',
      dtHistorico: '',
      historicos: [],
      detail: '',
      layout: 'list',
      modalNovoHistorico: false,
      modalProcesso: false,
      visible: false,
      exibiGrupo: 'none',
      exibiProcesso: 'none',
      labelLinkProcesso: '',
      moduloRetorno: '',
      pessoaRetonro: '',
    }
  }

  consultarAtendimento = (atendimento) => {
    this.atendimentoService.consultarAtendimento(atendimento)
      .then(response => {
        this.setState({atendimento: response.data});
        this.setState({pessoa: response.data.pessoa.nome});
        this.setState({assunto: response.data.assunto});
        this.setState({grupo: response.data.grupo.nome});
        if(response.data.processo != null) {
          this.setState({selectProcesso: response.data.processo.nrCnj});
          this.setState({labelLinkProcesso: 'Alterar Processo'});
        } else {
          this.setState({selectProcesso: 'Nenhum Processo'});
          this.setState({labelLinkProcesso: 'Adicionar Processo'});
        }
        this.setState({dtAtendimento: response.data.dtAtendimento});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarHistorico = (atendimento) => {
    this.atendimentoService.consultarHistoricos(atendimento)
      .then(response => {
        this.setState({historicos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGruposTrabalho = () => {
    const usuarioLogado = this.context.usuarioAutenticado

    this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async onGrupoTrabalhoChange(e) {
    await this.setState({selectGrupo: e.value});
    this.alterarAtendimentoGrupo();
  }

  exibirGrupo = () => {
    if(this.state.exibiGrupo == 'none') {
      this.setState({exibiGrupo: ''})
      this.listarGruposTrabalho();
    } else {
      this.setState({exibiGrupo: 'none'})
    }
  }

  exibirProcesso = () => {
    if(this.state.exibiProcesso == 'none') {
      this.setState({exibiProcesso: ''})
    } else {
      this.setState({exibiProcesso: 'none'})
    }
  }

  alterarAtendimentoGrupo = () => {
    this.atendimentoService.alterarAtendimentoGrupo({
      codigo: this.state.atendimento.codigo,
      grupo: this.state.selectGrupo,
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Atendimentos', detail:'Grupo Alterado!', life: 4000});
      this.consultarAtendimento(this.state.atendimento.codigo);
      this.setState({exibiGrupo: 'none'});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
    })
  }

  alterarAtendimentoProcesso = () => {
    this.atendimentoService.alterarAtendimentoProcesso({
      codigo: this.state.atendimento.codigo,
      processo: this.state.processo,
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Atendimentos', detail:'Processo alterado!', life: 4000});
      this.consultarAtendimento(this.state.atendimento.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
    })
  }

  cadastrarNovoHistorico = () => {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.historico == '') {
      this.toast.show({severity:'error', summary: 'Atendimentos', detail:'Informe o Histórico', life: 4000});
      return false;
    }

    this.atendimentoService.cadastrarHistorico({
      atendimento: this.state.atendimento,
      historico: this.state.historico,
      usuario: usuarioLogado
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Atendimentos', detail:'Histórico registrado com sucesso', life: 4000});
      this.consultarHistorico(this.state.atendimento.codigo);
      this.fecharModal('modalNovoHistorico');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
    })
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({historico: ''});
    this.setState(state);
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  confirmaExclusao(historico) {
    this.setState({historico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir histórico?',
        header: 'Exclusão de histórico de atendimento',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirHistorico = () => {
    this.atendimentoService.excluirHistorico(this.state.historico.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Atendimentos', detail:'Histórico excluiído com sucesso', life: 4000});
        this.consultarHistorico(this.state.atendimento.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  accept() {
    this.excluirHistorico();
  }

  voltar = () => {
    if(this.state.moduloRetorno == 'atendimento') {
      this.props.history.push('/atendimentos');
    } else {
      this.props.history.push(`/consultarPessoas/${this.state.pessoaRetorno}`);
    }
  }

  consultarProcessoPorIndice = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    
    const indice = {
      indice: this.state.processoConsulta,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        this.abrirModal('modalProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Selecionar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async selecionarProcesso(processo) {
    await this.processoService.consultarProcessoPorCodigo(processo.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({selectProcesso: response.data.nrCnj});
        this.alterarAtendimentoProcesso();
        this.setState({exibiProcesso: 'none'});
        this.setState({processoConsulta: ''});
        this.fecharModal('modalProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atendimentos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  componentDidMount() {
    const params = this.props.match.params;
    this.setState({moduloRetorno: params.modulo});
    this.setState({pessoaRetorno: params.pessoa});
    if(params.codigo) {
      this.consultarAtendimento(params.codigo);
      this.consultarHistorico(params.codigo)
    }
  }

  template(data) {
    return (
        <div>
          <div className="row">
            <div className="col-sm-8">
              <div className="form-group">
                <InputTextarea id="registro" 
                               type="text" 
                               style={{width: '100%'}} 
                               value={data.historico}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"
                               rows={4} cols={30}/>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <span style={{color: '#4F88FF', fontStyle: 'italic'}}>{data.usuario.nome}</span>
                <p>{data.dtAtendimento}
                   <br></br>
                   <a onClick={() => this.confirmaExclusao(data)} title="Excluir Registro" style={{cursor: 'pointer', color: 'red'}}>Excluir</a>
                </p>
              </div>
            </div>
          </div>
        </div>
    );
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="pi pi-comments"></i>
                    <span> Histórico do Atendimento</span>
                  </h3>
                  <div style={{textAlign: 'right'}}>

                    <Button label="Voltar" 
                              onClick={this.voltar}
                              style={{height: '26px'}}
                              className="p-button-secondary p-button-text p-button-sm" />
                    &nbsp;
                    <Button label="Novo Histórico" 
                            onClick={() => this.abrirModal('modalNovoHistorico')}
                            data-toggle="modal" 
                            data-target="#modal-default"  
                            style={{height: '26px'}}
                            className="p-button-info p-button-text p-button-sm" />
                    &nbsp;
                    <Button icon="pi pi-print" 
                            onClick={() => this.abrirModal('modalNovoHistorico')}
                            title="Imprimir histórico da Pessoa"
                            data-toggle="modal" 
                            data-target="#modal-default"  
                            style={{height: '26px'}}
                            className="p-button-info p-button-text p-button-sm" />
                   
                  
                  </div>  
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div>
                          <span style={{fontSize: '20px', fontWeight: 'bold'}}>{this.state.assunto}</span>
                          <p>
                            <span style={{color: '#ccsfcc', fontWeight: 'bold'}}>{this.state.pessoa}</span>
                            <br></br>
                            <br></br>
                            <span style={{color: '#CCCCCC', fontWeight: 'bold'}}>{this.state.selectProcesso}</span>
                            <a style={{color: '#4F88FF', cursor: 'pointer'}} onClick={this.exibirProcesso} >&nbsp;{this.state.labelLinkProcesso}</a>
                            &nbsp;
                            &nbsp;
                            <Button icon="pi pi-undo"
                                  style={{display: `${this.state.exibiProcesso}`}}
                                  onClick={this.exibirProcesso}
                                  className="p-button-secondary p-button-text p-button-sm" />
                            &nbsp;
                            &nbsp;
                            <InputText value={this.state.processoConsulta} style={{width: '25%', height: '37px', display: `${this.state.exibiProcesso}`}}
                                       onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                       onChange={e => this.setState({processoConsulta: e.target.value})}
                                       id="processo"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            <br></br>
                            <span style={{color: '#CCCCCC', fontWeight: 'bold'}}>{this.state.grupo}</span>
                             <a style={{color: '#4F88FF', cursor: 'pointer'}} onClick={this.exibirGrupo} >&nbsp;Aterar Grupo de Assunto</a>
                             &nbsp;
                             &nbsp;
                             <Button icon="pi pi-undo"
                                    style={{display: `${this.state.exibiGrupo}`}}
                                    onClick={this.exibirGrupo}
                                    className="p-button-secondary p-button-text p-button-sm" />
                              &nbsp;
                              &nbsp;
                              <Dropdown value={this.state.selectGrupo} 
                                        options={this.state.grupos} style={{width: '21%', height: '37px', display: `${this.state.exibiGrupo}`}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onGrupoTrabalhoChange}
                                        id="grupoTrabalho"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          
                            <br></br>
                             Início:&nbsp; 
                             {this.state.dtAtendimento}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <DataView value={this.state.historicos}
                    layout={this.state.layout}
                    emptyMessage=" "
                    itemTemplate={this.template}/>
                </div>
              </div>
              <ConfirmDialog visible={this.state.visible} 
                             onHide={() => this.setState({ visible: false })} 
                             message="Are you sure you want to proceed?"
                             header="Confirmation"
                             icon="pi pi-exclamation-triangle" 
                             accept={() => this.excluirHistorico} 
                             reject={() => this.setState({visible: false})}/>
              {/**Incluir novo histórico */}
              <Dialog header="Novo Registro de Atendimento"
                      style={{ width: '50vw' }}
                      visible={this.state.modalNovoHistorico} 
                      footer={
                        <div alignItems="right">
                          <Button label="Cadastrar" 
                                  className="p-button-primery p-button-text"
                                  onClick={this.cadastrarNovoHistorico}/>
                          &nbsp;
                          <Button label="Cancelar" 
                                  className="p-button-secondary p-button-text"
                                  onClick={() => this.fecharModal('modalNovoHistorico')}/>
                        </div>
                      }
                      onHide={() => this.fecharModal('modalNovoHistorico')}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="formGroup">
                      <label>Histórico</label>
                      <InputTextarea id="historico" 
                                     type="text" 
                                     style={{width: '100%'}} 
                                     value={this.state.historico}
                                     onChange={(e) => this.setState({historico: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"
                                     rows={6} cols={30}/>
                    </div>
                  </div>
                </div>
              </Dialog>
              {/**Pesquisa de Processos */}
              <Dialog header="Busca de Processo"
                      visible={this.state.modalProcesso} 
                      style={{ width: '60vw' }} 
                      footer={
                        <Button label="Cancelar" 
                                className="p-button-secondary p-button-text"
                                onClick={() => this.fecharModal('modalProcesso')}/>
                      } 
                      onHide={() => this.fecharModal('modalProcesso')}>    

                  <DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                            paginatorRight selectionMode="multiple">
                    <Column field="pasta" header="Pasta"></Column>
                    <Column field="nrProcesso" header="Processo Original"></Column>
                    <Column field="nrCnj" header="Numeração Única"></Column>
                    <Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
                    <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
                    <Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                  </DataTable>
              </Dialog>
            </section>
          </div>
        </div>
      </>
    )
  }
}

HistoricoAtendimento.contextType = AuthContext;
export default withRouter(HistoricoAtendimento)